import React, { lazy, memo, Suspense } from 'react';
import { useSelector } from 'react-redux';

import { COPILOT_BAR, COPILOT_BAR_LIVE } from 'constants/Features';

import useCopilotBarScenarioMatch from './useCopilotBarScenarioMatch';

const CopilotBar = lazy(() => import('./index'));

const EnabledCopilotBar = memo(({ fallback }) => {
    const scenarioMatch = useCopilotBarScenarioMatch();

    return (
        <Suspense fallback={fallback}>
            <CopilotBar scenarioMatch={scenarioMatch} />
        </Suspense>
    );
});

EnabledCopilotBar.displayName = 'EnabledCopilotBar';

const LazyCopilotBar = memo(({ fallback = null }) => {
    const isCopilotBarEnabled = useSelector((state) => {
        const flagsmith = state.config?.flagsmith || {};
        return Boolean(flagsmith[COPILOT_BAR] || flagsmith[COPILOT_BAR_LIVE]);
    });

    if (!isCopilotBarEnabled) return null;

    return <EnabledCopilotBar fallback={fallback} />;
});

LazyCopilotBar.displayName = 'LazyCopilotBar';

export default LazyCopilotBar;
